import axios from 'axios';

const resetAvailableEntities = async ({debug, baseUri, env, apiKey}) => {
  const urlObj = new URL(`${baseUri}/${env}/resetAvailableEntities`);

  const { data } = await axios.delete(
    urlObj,
    { headers: { 'x-api-key': apiKey, 'Content-type': 'application/json' } }
  );
  debug({ data });
};

const genCredentialsOnClientApi = async ({ debug, baseUri, task, env, apikey, ...params }) => {
  const urlObj = new URL(`${baseUri}/credentials/${task}/${env}`);
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      urlObj.searchParams.set(key, value);
    });
  }
  const uri = urlObj.toString();
  debug && debug('uri:', uri);
  const { data } = await axios.get(uri, { headers: { 'x-api-key': apikey } });
  const { accessKeyId, secretAccessKey, sessionToken } = data;
  return { accessKeyId, secretAccessKey, sessionToken };
};

const getTenants = async ({ debug, baseUri, env, apikey }) => {
  const uri = `${baseUri}/tenants/${env}`;
  debug('requesting:', uri);
  const { data } = await axios.get(uri, { headers: { 'x-api-key': apikey } });
  debug('response-data', data);
  return data;
};

const getSupportedSources = async ({ debug, baseUri, env, flow, apikey }) => {
  const urlObj = new URL(`${baseUri}/${env}/${flow}/supportedSources`);
  const headers = { 'x-api-key': apikey };
  const uri = urlObj.toString();
  debug && debug('uri:', uri);
  const { data } = await axios.get(uri, { headers });
  return data;
};

const getSupportedTargets = async ({ debug, baseUri, env, flow, apikey }) => {
  const urlObj = new URL(`${baseUri}/${env}/${flow}/supportedTargets`);
  const headers = { 'x-api-key': apikey };
  const uri = urlObj.toString();
  debug && debug('uri:', uri);
  const { data } = await axios.get(uri, { headers });
  return data;
};

const getSupportedConnectors = async ({ debug, baseUri, env, flow, apikey }) => {
  const urlObj = new URL(`${baseUri}/v2/${env}/${flow}/supportedConnectors`);
  const headers = { 'x-api-key': apikey };
  const uri = urlObj.toString();
  debug && debug('uri:', uri);
  const { data } = await axios.get(uri, { headers });
  return data;
};

const getLinkedSources = async ({ debug, baseUri, env, flow, tenant, apikey, config }) => {
  const urlObj = new URL(`${baseUri}/${env}/${flow}/${tenant}/linkedSources`);
  if (config) {
    urlObj.searchParams.set('config', 'true');
  }
  const headers = { 'x-api-key': apikey };
  const uri = urlObj.toString();
  debug && debug('uri:', uri);
  const { data } = await axios.get(uri, { headers });
  return data;
};

const getLinkedConnectors = async ({ debug, baseUri, env, flow, tenant, apikey, config }) => {
  const urlObj = new URL(`${baseUri}/v2/${env}/${flow}/${tenant}/linkedConnectors`);
  if (config) {
    urlObj.searchParams.set('config', 'true');
  }
  const headers = { 'x-api-key': apikey };
  const uri = urlObj.toString();
  debug && debug('uri:', uri);
  const { data } = await axios.get(uri, { headers });
  return data;
};

const patchLinkedSourceConfig = async ({ debug, baseUri, env, flow, tenant, apikey, connectorId, config }) => {
  const urlObj = new URL(`${baseUri}/${env}/${flow}/${tenant}/linkedSources`);
  const headers = { 'x-api-key': apikey };
  const uri = urlObj.toString();
  const body = { tap: connectorId, config };
  debug && debug('uri:', uri);
  const { data } = await axios.patch(uri, body, { headers });
  return data;
};

const patchLinkedConnectorConfig = async ({ debug, baseUri, env, flow, tenant, apikey, connectorId, config }) => {
  const urlObj = new URL(`${baseUri}/v2/${env}/${flow}/${tenant}/linkedConnectors`);
  const headers = { 'x-api-key': apikey };
  const uri = urlObj.toString();
  const body = { connector_id: connectorId, config };
  debug && debug('uri:', uri);
  const { data } = await axios.patch(uri, body, { headers });
  return data;
};

const getSupportedFlows = async ({ debug, baseUri, env, apikey }) => {
  const urlObj = new URL(`${baseUri}/${env}/flows/supported`);
  const headers = { 'x-api-key': apikey };
  const uri = urlObj.toString();
  debug && debug('uri:', uri);
  const { data } = await axios.get(uri, { headers });
  return data;
};

const getSupportedFlow = async ({ debug, baseUri, env, flow, apikey }) => {
  const urlObj = new URL(`${baseUri}/${env}/flows/${flow}/supported`);
  const headers = { 'x-api-key': apikey };
  const uri = urlObj.toString();
  debug && debug('uri:', uri);
  const { data } = await axios.get(uri, { headers });
  return data;
};

const deleteTenantSchedules = async ({ debug, baseUri, env, apikey, tenant }) => {
  const urlObj = new URL(`${baseUri}/tenant/${env}/${tenant}?schedules_only=true`);
  const headers = { 'x-api-key': apikey };
  const uri = urlObj.toString();
  debug && debug('uri:', uri);
  const { data } = await axios.delete(uri, { headers });
  return data;
};

export {
  genCredentialsOnClientApi,
  getTenants,
  getSupportedSources,
  getSupportedConnectors,
  getLinkedSources,
  getLinkedConnectors,
  patchLinkedSourceConfig,
  patchLinkedConnectorConfig,
  getSupportedFlows,
  deleteTenantSchedules,
  getSupportedFlow,
  getSupportedTargets,
  resetAvailableEntities
};
